import { Html, useProgress } from '@react-three/drei';
import { useFrame } from '@react-three/fiber';
import { useRef } from 'react';

export default function Loader() {
  const { progress } = useProgress()

  return (
    <Html center>
      <div className="flex flex-col items-center justify-center bg-black text-white w-screen h-screen z-50">
        <div className="text-4xl font-bold tracking-widest mb-8 uppercase" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
          Tunahan Coşgun
        </div>
        <div className="w-64 h-0.5 bg-gray-900 rounded-full overflow-hidden">
          <div
            className="h-full bg-white transition-all duration-300 ease-out"
            style={{ width: `${progress}%` }}
          />
        </div>
        <div className="mt-4 text-xs text-gray-500 font-mono tracking-widest">
          LOADING EXPERIENCE {progress.toFixed(0)}%
        </div>
      </div>
    </Html>
  )
}